import { useApi } from '@/api';
import { Page } from '@/components';
import {
  CryptoIcon,
  Flex,
  Heading,
  KpiSkeleton,
  NetworkIcon,
  ProtocolIcon
} from '@blockanalitica/ui';
import { useParams } from 'react-router';
import AllocationTableBreakdown from './AllocationTableBreakdown';
import APYKpi from './APYKpi';
import AUMKPI from './AUMKPI';
import BackedTableBreakdown from './BackedTableBreakdown';
import EventsFancyTable from './EventsFancyTable';
import InfoSection from './InfoSection';
import RevenueSection from './RevenueSection';
type DataResponse = {
  assets: string;
  assets_usd: string;
  network: string;
  address: string;
  wallet_address: string;
  symbol: string;
  name: string;
  principal: string;
  profit_total: string;
  pending_amount?: string;
  cooldown_end?: number;
  asset_symbol: string;
  asset_address: string;
  asset_name: string;
  protocol: string;
  price: string;
  wallet_label?: string;
  idle?: string;
  rate_1d_avg: string | number | null;
  rate_7d_avg: string | number | null;
  last_event_datetime: string;
  type: string;
  shares: string;
  token_total_supply: string;
  rate: string | number | null;
  aum: string;
  token_type: string;
  token_group: string;
};

export default function ALMProxyPage() {
  const { network, address, tokenAddress } = useParams();
  const [data, error] = useApi<DataResponse>({
    url: `/sparkstar/sll/tokens/${network}/${address}/${tokenAddress}/`
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <KpiSkeleton />;
  }

  return (
    <Page
      title={
        <Flex
          flexDirection="row"
          gap="s"
          alignItems="center"
          alignContent="center">
          <Flex alignItems="center" gap="3xs">
            <NetworkIcon network={data.network} size="5" />
            {data.protocol && (
              <ProtocolIcon protocol={data.protocol} size="5" />
            )}
            {data.asset_symbol && (
              <CryptoIcon
                name={data.asset_symbol}
                address={data.asset_address}
                network={data.network}
                size="5"
              />
            )}
          </Flex>
          <Flex flexDirection="column" gap="2xs" alignItems="center">
            <Heading>{data.symbol ? data.symbol : data.asset_symbol}</Heading>
          </Flex>
        </Flex>
      }>
      {data.token_group === 'allocation' || data.token_type === 'allocation' ? (
        <Flex flexDirection="column" gap="s">
          <Flex
            flexDirection={['column', 'column', 'row']}
            gap={['m', 's']}
            alignItems={['stretch', 'stretch', 'flex-start']}>
            <Flex flex="1">
              <AUMKPI />
            </Flex>
            <Flex flex="1">
              <APYKpi />
            </Flex>
          </Flex>
          <AllocationTableBreakdown symbol={data.asset_symbol} />
          <BackedTableBreakdown />
          <RevenueSection />

          <InfoSection data={data} />
        </Flex>
      ) : (
        <AUMKPI isSingle={true} />
      )}

      <EventsFancyTable />
    </Page>
  );
}
